// extracted by mini-css-extract-plugin
export var simpleBlock = "simpleBlock-module--simpleBlock--ze0h+";
export var simpleBlockWrap = "simpleBlock-module--simpleBlockWrap--y8cGa";